import { render, staticRenderFns } from "./planAndPaymentsOrder.vue?vue&type=template&id=2ec60634&scoped=true&"
import script from "./planAndPaymentsOrder.vue?vue&type=script&lang=js&"
export * from "./planAndPaymentsOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec60634",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
